import { useCallback } from 'react';
import { matchPath, useLocation } from 'react-router-dom';
import { Stack } from '@mui/material';

import routes from '@routes';

import { useFlagFixed } from '@common/utils/flags/use-flag-fixed';
import { Flags } from '@common/utils/flags/feature-flags';

import AppSidebarItem, { AppSidebarItemWrapper } from '@common/ui/AppSidebarItem';

import NewRequest from '../components/NewRequest';
import { AnalyticsEvents } from '@common/utils/analytics/events';

export default function Navigation({ minimized }: { minimized?: boolean }) {
  const { isEnabled: isMyAccessEnabled } = useFlagFixed(Flags.PORTAL_MY_ACCESS);

  const location = useLocation();
  const isActive = useCallback(
    (prefix: string | string[]) => {
      const prefixes = Array.isArray(prefix) ? prefix : [prefix];

      for (const p of prefixes) {
        if (matchPath({ path: p, end: false }, location.pathname)) {
          return true;
        }
      }

      return false;
    },
    [location],
  );

  return (
    <Stack direction="column">
      <AppSidebarItemWrapper>
        <NewRequest minimized={minimized} enableAnimation />
      </AppSidebarItemWrapper>
      {isMyAccessEnabled && (
        <AppSidebarItem
          icon="playlist_play"
          label="My Access"
          minimized={minimized}
          to={routes.MyAccess.path}
          active={isActive('/my-access')}
          enableAnimation
          data-trigger={AnalyticsEvents.MyAccessInitiated}
        />
      )}
      <AppSidebarItem
        icon="chat_paste_go"
        label="My Requests"
        minimized={minimized}
        to={routes.OpenRequests.path}
        active={isActive(['/requests', '/new-request'])}
        enableAnimation
        data-trigger={AnalyticsEvents.MyRequestsInitiated}
      />
      <AppSidebarItem
        icon="inventory"
        label="My Tasks"
        minimized={minimized}
        to={routes.Tasks.path}
        active={isActive('/tasks')}
        enableAnimation
        data-trigger={AnalyticsEvents.MyTasksInitiated}
      />
    </Stack>
  );
}
